module.exports = __webpack_public_path__ + "d18832c46f7d462602ec345f460a0181.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-regular.woff
// module id = 77
// module chunks = 0